import * as React from 'react';
import { Text, TextVariants } from '@patternfly/react-core';
import UserInterface from '@app/Interface/UserInterface';

interface UserDisplayNameProps {
    user: UserInterface;
    currentUser: UserInterface;
}

const UserDisplayName: React.FC<UserDisplayNameProps> = ({ user, currentUser }) => {

    let displayName = user.email;

    if (user.firstName || user.lastName) {
        displayName = `${user.email} - ${user.firstName} ${user.lastName}`;
    }

    return (
        <Text>
            {displayName}
            {currentUser.id === user.id && <Text component={TextVariants.small} className="pf-u-primary-color-100"> <i>(you)</i></Text>}
        </Text>);

}

export default UserDisplayName;
